// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://db.onlinewebfonts.com/c/d30081f8147d8a4596ff8347f6fd793c?family=Susan+Classic+W01+Bold);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Login.css */

.login-container {
    border: 1px solid teal;
    display: flex;
    height: 100vh; 
  }
  
  .image-container {
    /* position: relative; */
    height: 100vh;
    padding: 90px 0 0 50px;
    overflow: hidden;
  }
.image {
    width: 100%;
    height: auto;
    margin-top: 9%;
  }
.heading {
    font-weight: 700 !important;
    line-height: 1.5;
    color: white;

  }
  .image-container span {
    display: block;
    color: white;
    line-height: 1.5; 
  }
  .form-container {
    padding: 90px 100px 0 0;
  }
  .div-form-container{
    /* border: 1px solid red; */
    padding-left: 5%;
    width: 350px;
    /* max-width: 100%; */

  }
  .normal-div{
    padding: 10px;
    border: 1px solid red;
    flex: 1 1;
  }

  .chart-container {
    text-align: center;
  }
  
  .chart-wrapper {
    position: relative;
  }
  
  .center-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  
.my-doughnut-chart-1 canvas{
    z-index: 999 !important;
}  
.my-doughnut-chart-1 {
  position: relative;
  width: 150px;
  height: 150px;
  background-color: transparent;
}


.my-doughnut-chart-1 .icon-container {
  position: absolute;
  top: 55%;
  left: 50%;
  transform: translate(-50%, -50%);
}

/* LinearProgressBar*/

.linear-progress-container {
  position: relative;
}

.linear-progress-bar {
  width: 85%;
  height: 45px;
  border-radius: 0 5px 5px 0;
  background-color: transparent;
}

.linear-progress-bar-color {
  background-color: var(--progress-color);
}

.progress-text {
  position: absolute;
  margin-top: -40px;
  font-size: 24px;
  font-weight: bold;
}

/* ForgotPasswordModal */

.forgot-password-modal {
  max-width: 400px;
}

.forgot-password-app-bar {
  background-color: #f7f7f7;
  color: black;
}

.forgot-password-title {
  flex-grow: 1;
}

.forgot-password-dialog-content {
  margin: 3;
}

.forgot-password-email-input {
  width: 88%;
  margin: 18px;
}

.forgot-password-actions {
  justify-content: center;
}

.forgot-password-button {
  text-transform: inherit;
  border-radius: 30px;
  margin-bottom: 10px;
}
/* CustomAppBar */

.custom-app-bar {
  position: fixed;
  color: #fff; 
}

.custom-toolbar {
  display: flex;
  justify-content: space-between;
}

.custom-email {
  margin-right: 16px;
}

.custom-menu {
  margin-top: 10px;
}

.custom-menu-item {
  padding: 15px !important;
}

.custom-icon {
  color: inherit;
}

/* Sidebar */

.sidebar {
  display: flex;
}

.sidebar-drawer {
  width: 320px;
  flex-shrink: 0;
}

.sidebar-drawer-paper {
  width: 320px;
  box-sizing: border-box;
}

.sidebar-logo-container {
  display: flex;
  align-items: center;
  margin-top: 20px;
  border-bottom: 1px solid #ccc;
  padding: 35px 15px;
}

.sidebar-logo-container2 {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
  border-bottom: 1px solid #ccc;
  padding: 35px 15px;
}

.sidebar-logo1 {
  flex: 1 1;
  max-width: 150px;
  object-fit: cover;
  position: relative;
}

.sidebar-logo2 {
  flex: 1 1;
  max-width: 120px;
}

.sidebar-logo2 {
  margin-left: -15px;
}

.sidebar-logo-text {
  position: absolute;
  margin: -20px 0 0 45px;
  font-size: 9px;
  color: rgb(241, 137, 16);
  font-family: "Susan Classic W01 Bold, sans-serif";
}

.sidebar-divider {
  width: 1px;
  height: 100px;
  background: #ccc;
  margin-left: -15px;
}

.sidebar-tabs {
  color: #e76943 !important;
}

.sidebar-tab {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: flex-start;
  padding: 12px;
  cursor: pointer;
}

.sidebar-tab:hover {
  color: #e76943 !important;
  font-weight: bold;
}

.sidebar-tab-active {
  background-color: #fcece8;
  color: #e76943 !important;
  font-weight: bold;
}
/* Dashboard.css */

/* Main container */
.dashboard-container {
  padding: 0 15px;
}

/* Welcome message */
.dashboard-container h1 {
  font-size: 24px;
  margin-bottom: 10px;
}

/* Overview paragraph */
.dashboard-container p {
  color: #5f5f5f;
  margin-bottom: 15px;
}

/* Flex container for the first row */
.dashboard-row {
  display: flex;
  margin-bottom: 15px;
}

/* Style for each card in the first row */
.dashboard-card {
  flex: 1 1;
  background-color: #f0efe9;
  margin-right: 20px;
  border-radius: 8px;
}

/* Card header link style */
.dashboard-card-header {
  color: #b0aeb1;
  font-size: 12px;
  text-align: right;
  padding: 12px;
  text-decoration: underline;
  cursor: pointer;
  border-bottom: 1px solid white;
}

/* Individual data display inside the card */
.dashboard-data {
  display: flex;
  justify-content: space-between;
  padding: 20px;
  align-items: center;
}

/* Employee count display */
.dashboard-data div:first-child {
  font-size: 16px;
}

/* Number display in the card */
.dashboard-data div:last-child {
  font-size: 24px;
}

/* Second row styling */
.dashboard-card-2 {
  flex: 1 1;
  background-color: #fff;
  margin-right: 20px;
  border-radius: 8px;
}

/* Date display style in the second card */
.dashboard-card-2-date {
  font-size: 12px;
  color: #ccbeb6;
  padding: 0 20px;
}

/* Style for CircularGraphWithIcon */
.circular-graph-container {
  padding: 20px 0;
}

/* Styling for Consultation section */
.consultation-section {
  padding: 0 15px;
  background-color: #fff;
  margin-bottom: 20px;
}

/* Header of the Consultation section */
.consultation-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 0;
  border-bottom: 1px solid #eeeff2;
}

/* Styling for form control in Consultation section */
.consultation-form-control {
  width: 150px;
  height: 40px;
  border-radius: 8px;
}

/* Styling for the linear progress bar in Consultation section */
.consultation-linear-progress {
  width: 100%;
  height: 15px;
  border-radius: 0 5px 5px 0;
  background-color: #f7f7f7;
}

/* Styling for the date dropdown in Consultation section */
.consultation-date-dropdown {
  display: flex;
}

/* Style for the Recommended Activities and Resources sections */
.activities-resources-card {
  flex: 1 1;
  background-color: #fff;
  margin-right: 20px;
}

/* Header of the Recommended Activities and Resources sections */
.activities-resources-header {
  font-size: 20px;
  padding: 15px;
  border-bottom: 1px solid #eeeff2;
}

/* Individual data display inside Recommended Activities and Resources sections */
.activities-resources-data {
  display: flex;
  justify-content: space-between;
  padding: 15px;
  margin-top: 15px;
}

/* Style for the show more link in Recommended Activities and Resources sections */
.show-more-link {
  text-align: center;
  border-top: 1px solid #eeeff2;
  padding: 15px;
  position: relative;
}

/* Style for the show more link text and arrow icon */
.show-more-link-text {
  text-align: center;
  margin-top: -28px;
  margin-left: 36%;
  background-color: #fff;
  cursor: pointer;
  position: absolute;
  display: flex;
}

/* Style for the Activities and Resources table */
.activities-resources-table {
  overflow: auto;
  height: 200px;
}

.card-container {
  padding: 0 25px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(40%, 1fr)); 
  gap: 20px; 
  margin-bottom: 25px;
}

.bottom-card-container{
  /* padding: 0 25px; */
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(33%, 1fr)); 
  /* gap: 20px; */
}
/* .bottom-card-container>div{
  background-color: #fff;
} */
.workshop-card-img{
  /* border: 5px solid black; */
  /* height: 250px; */
text-align: center;
}
.workshop-card-img img{
  /* border: 5px solid red; */
  width:75%;
  height: 85%;
  border-radius: 8px;
}

.chart-container {
  display: flex;
  justify-content: center;
  align-items: center;
  
}
.assessment-container {
  padding: 0 25px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(30%, 1fr)); 
  gap: 20px; 
  margin-bottom: 25px;
}

.two-div-container {
  padding: 0 25px;
  display: grid;
  grid-template-columns: 1fr 1.5fr; 
  gap: 40px; 
  margin-bottom: 25px;
}

.yoga-session-select {
  width: 200px; 
  padding: 5px 10px; 
  font-size: 18px; 
  border: 1px solid #A0AEC0; 
  border-radius: 10px; 
  background-color: #fff; 
  color: #2D3748; 
}

.yoga-session-select option {
  color: gray; 
}


.yoga-session-select::-ms-expand {
  display: none; 
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,cAAc;;AAGd;IACI,sBAAsB;IACtB,aAAa;IACb,aAAa;EACf;;EAEA;IACE,wBAAwB;IACxB,aAAa;IACb,sBAAsB;IACtB,gBAAgB;EAClB;AACF;IACI,WAAW;IACX,YAAY;IACZ,cAAc;EAChB;AACF;IACI,2BAA2B;IAC3B,gBAAgB;IAChB,YAAY;;EAEd;EACA;IACE,cAAc;IACd,YAAY;IACZ,gBAAgB;EAClB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,2BAA2B;IAC3B,gBAAgB;IAChB,YAAY;IACZ,qBAAqB;;EAEvB;EACA;IACE,aAAa;IACb,qBAAqB;IACrB,SAAO;EACT;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;EAClC;;AAEF;IACI,uBAAuB;AAC3B;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,6BAA6B;AAC/B;;;AAGA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA,qBAAqB;;AAErB;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;AACnB;;AAEA,wBAAwB;;AAExB;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;AACA,iBAAiB;;AAEjB;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,cAAc;AAChB;;AAEA,YAAY;;AAEZ;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;EACd,wBAAwB;EACxB,iDAAiD;AACnD;;AAEA;EACE,UAAU;EACV,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,iBAAiB;AACnB;AACA,kBAAkB;;AAElB,mBAAmB;AACnB;EACE,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,yCAAyC;AACzC;EACE,SAAO;EACP,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,2BAA2B;AAC3B;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,0BAA0B;EAC1B,eAAe;EACf,8BAA8B;AAChC;;AAEA,4CAA4C;AAC5C;EACE,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE,eAAe;AACjB;;AAEA,+BAA+B;AAC/B;EACE,eAAe;AACjB;;AAEA,uBAAuB;AACvB;EACE,SAAO;EACP,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,0CAA0C;AAC1C;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA,oCAAoC;AACpC;EACE,eAAe;AACjB;;AAEA,qCAAqC;AACrC;EACE,eAAe;EACf,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,gCAAgC;AAClC;;AAEA,qDAAqD;AACrD;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;;AAEA,gEAAgE;AAChE;EACE,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA,0DAA0D;AAC1D;EACE,aAAa;AACf;;AAEA,gEAAgE;AAChE;EACE,SAAO;EACP,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,gEAAgE;AAChE;EACE,eAAe;EACf,aAAa;EACb,gCAAgC;AAClC;;AAEA,iFAAiF;AACjF;EACE,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,gBAAgB;AAClB;;AAEA,kFAAkF;AAClF;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;EACb,kBAAkB;AACpB;;AAEA,qDAAqD;AACrD;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,aAAa;AACf;;AAEA,iDAAiD;AACjD;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,eAAe;EACf,aAAa;EACb,0DAA0D;EAC1D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,0DAA0D;EAC1D,eAAe;AACjB;AACA;;GAEG;AACH;EACE,6BAA6B;EAC7B,mBAAmB;AACrB,kBAAkB;AAClB;AACA;EACE,2BAA2B;EAC3B,SAAS;EACT,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;;AAErB;AACA;EACE,eAAe;EACf,aAAa;EACb,0DAA0D;EAC1D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;;AAGA;EACE,aAAa;AACf","sourcesContent":["/* Login.css */\n@import url(https://db.onlinewebfonts.com/c/d30081f8147d8a4596ff8347f6fd793c?family=Susan+Classic+W01+Bold);\n\n.login-container {\n    border: 1px solid teal;\n    display: flex;\n    height: 100vh; \n  }\n  \n  .image-container {\n    /* position: relative; */\n    height: 100vh;\n    padding: 90px 0 0 50px;\n    overflow: hidden;\n  }\n.image {\n    width: 100%;\n    height: auto;\n    margin-top: 9%;\n  }\n.heading {\n    font-weight: 700 !important;\n    line-height: 1.5;\n    color: white;\n\n  }\n  .image-container span {\n    display: block;\n    color: white;\n    line-height: 1.5; \n  }\n  .form-container {\n    padding: 90px 100px 0 0;\n  }\n  .div-form-container{\n    /* border: 1px solid red; */\n    padding-left: 5%;\n    width: 350px;\n    /* max-width: 100%; */\n\n  }\n  .normal-div{\n    padding: 10px;\n    border: 1px solid red;\n    flex: 1;\n  }\n\n  .chart-container {\n    text-align: center;\n  }\n  \n  .chart-wrapper {\n    position: relative;\n  }\n  \n  .center-icon {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n  }\n  \n.my-doughnut-chart-1 canvas{\n    z-index: 999 !important;\n}  \n.my-doughnut-chart-1 {\n  position: relative;\n  width: 150px;\n  height: 150px;\n  background-color: transparent;\n}\n\n\n.my-doughnut-chart-1 .icon-container {\n  position: absolute;\n  top: 55%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n/* LinearProgressBar*/\n\n.linear-progress-container {\n  position: relative;\n}\n\n.linear-progress-bar {\n  width: 85%;\n  height: 45px;\n  border-radius: 0 5px 5px 0;\n  background-color: transparent;\n}\n\n.linear-progress-bar-color {\n  background-color: var(--progress-color);\n}\n\n.progress-text {\n  position: absolute;\n  margin-top: -40px;\n  font-size: 24px;\n  font-weight: bold;\n}\n\n/* ForgotPasswordModal */\n\n.forgot-password-modal {\n  max-width: 400px;\n}\n\n.forgot-password-app-bar {\n  background-color: #f7f7f7;\n  color: black;\n}\n\n.forgot-password-title {\n  flex-grow: 1;\n}\n\n.forgot-password-dialog-content {\n  margin: 3;\n}\n\n.forgot-password-email-input {\n  width: 88%;\n  margin: 18px;\n}\n\n.forgot-password-actions {\n  justify-content: center;\n}\n\n.forgot-password-button {\n  text-transform: inherit;\n  border-radius: 30px;\n  margin-bottom: 10px;\n}\n/* CustomAppBar */\n\n.custom-app-bar {\n  position: fixed;\n  color: #fff; \n}\n\n.custom-toolbar {\n  display: flex;\n  justify-content: space-between;\n}\n\n.custom-email {\n  margin-right: 16px;\n}\n\n.custom-menu {\n  margin-top: 10px;\n}\n\n.custom-menu-item {\n  padding: 15px !important;\n}\n\n.custom-icon {\n  color: inherit;\n}\n\n/* Sidebar */\n\n.sidebar {\n  display: flex;\n}\n\n.sidebar-drawer {\n  width: 320px;\n  flex-shrink: 0;\n}\n\n.sidebar-drawer-paper {\n  width: 320px;\n  box-sizing: border-box;\n}\n\n.sidebar-logo-container {\n  display: flex;\n  align-items: center;\n  margin-top: 20px;\n  border-bottom: 1px solid #ccc;\n  padding: 35px 15px;\n}\n\n.sidebar-logo-container2 {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 20px;\n  border-bottom: 1px solid #ccc;\n  padding: 35px 15px;\n}\n\n.sidebar-logo1 {\n  flex: 1;\n  max-width: 150px;\n  object-fit: cover;\n  position: relative;\n}\n\n.sidebar-logo2 {\n  flex: 1;\n  max-width: 120px;\n}\n\n.sidebar-logo2 {\n  margin-left: -15px;\n}\n\n.sidebar-logo-text {\n  position: absolute;\n  margin: -20px 0 0 45px;\n  font-size: 9px;\n  color: rgb(241, 137, 16);\n  font-family: \"Susan Classic W01 Bold, sans-serif\";\n}\n\n.sidebar-divider {\n  width: 1px;\n  height: 100px;\n  background: #ccc;\n  margin-left: -15px;\n}\n\n.sidebar-tabs {\n  color: #e76943 !important;\n}\n\n.sidebar-tab {\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n  justify-content: flex-start;\n  padding: 12px;\n  cursor: pointer;\n}\n\n.sidebar-tab:hover {\n  color: #e76943 !important;\n  font-weight: bold;\n}\n\n.sidebar-tab-active {\n  background-color: #fcece8;\n  color: #e76943 !important;\n  font-weight: bold;\n}\n/* Dashboard.css */\n\n/* Main container */\n.dashboard-container {\n  padding: 0 15px;\n}\n\n/* Welcome message */\n.dashboard-container h1 {\n  font-size: 24px;\n  margin-bottom: 10px;\n}\n\n/* Overview paragraph */\n.dashboard-container p {\n  color: #5f5f5f;\n  margin-bottom: 15px;\n}\n\n/* Flex container for the first row */\n.dashboard-row {\n  display: flex;\n  margin-bottom: 15px;\n}\n\n/* Style for each card in the first row */\n.dashboard-card {\n  flex: 1;\n  background-color: #f0efe9;\n  margin-right: 20px;\n  border-radius: 8px;\n}\n\n/* Card header link style */\n.dashboard-card-header {\n  color: #b0aeb1;\n  font-size: 12px;\n  text-align: right;\n  padding: 12px;\n  text-decoration: underline;\n  cursor: pointer;\n  border-bottom: 1px solid white;\n}\n\n/* Individual data display inside the card */\n.dashboard-data {\n  display: flex;\n  justify-content: space-between;\n  padding: 20px;\n  align-items: center;\n}\n\n/* Employee count display */\n.dashboard-data div:first-child {\n  font-size: 16px;\n}\n\n/* Number display in the card */\n.dashboard-data div:last-child {\n  font-size: 24px;\n}\n\n/* Second row styling */\n.dashboard-card-2 {\n  flex: 1;\n  background-color: #fff;\n  margin-right: 20px;\n  border-radius: 8px;\n}\n\n/* Date display style in the second card */\n.dashboard-card-2-date {\n  font-size: 12px;\n  color: #ccbeb6;\n  padding: 0 20px;\n}\n\n/* Style for CircularGraphWithIcon */\n.circular-graph-container {\n  padding: 20px 0;\n}\n\n/* Styling for Consultation section */\n.consultation-section {\n  padding: 0 15px;\n  background-color: #fff;\n  margin-bottom: 20px;\n}\n\n/* Header of the Consultation section */\n.consultation-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 15px 0;\n  border-bottom: 1px solid #eeeff2;\n}\n\n/* Styling for form control in Consultation section */\n.consultation-form-control {\n  width: 150px;\n  height: 40px;\n  border-radius: 8px;\n}\n\n/* Styling for the linear progress bar in Consultation section */\n.consultation-linear-progress {\n  width: 100%;\n  height: 15px;\n  border-radius: 0 5px 5px 0;\n  background-color: #f7f7f7;\n}\n\n/* Styling for the date dropdown in Consultation section */\n.consultation-date-dropdown {\n  display: flex;\n}\n\n/* Style for the Recommended Activities and Resources sections */\n.activities-resources-card {\n  flex: 1;\n  background-color: #fff;\n  margin-right: 20px;\n}\n\n/* Header of the Recommended Activities and Resources sections */\n.activities-resources-header {\n  font-size: 20px;\n  padding: 15px;\n  border-bottom: 1px solid #eeeff2;\n}\n\n/* Individual data display inside Recommended Activities and Resources sections */\n.activities-resources-data {\n  display: flex;\n  justify-content: space-between;\n  padding: 15px;\n  margin-top: 15px;\n}\n\n/* Style for the show more link in Recommended Activities and Resources sections */\n.show-more-link {\n  text-align: center;\n  border-top: 1px solid #eeeff2;\n  padding: 15px;\n  position: relative;\n}\n\n/* Style for the show more link text and arrow icon */\n.show-more-link-text {\n  text-align: center;\n  margin-top: -28px;\n  margin-left: 36%;\n  background-color: #fff;\n  cursor: pointer;\n  position: absolute;\n  display: flex;\n}\n\n/* Style for the Activities and Resources table */\n.activities-resources-table {\n  overflow: auto;\n  height: 200px;\n}\n\n.card-container {\n  padding: 0 25px;\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(40%, 1fr)); \n  gap: 20px; \n  margin-bottom: 25px;\n}\n\n.bottom-card-container{\n  /* padding: 0 25px; */\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(33%, 1fr)); \n  /* gap: 20px; */\n}\n/* .bottom-card-container>div{\n  background-color: #fff;\n} */\n.workshop-card-img{\n  /* border: 5px solid black; */\n  /* height: 250px; */\ntext-align: center;\n}\n.workshop-card-img img{\n  /* border: 5px solid red; */\n  width:75%;\n  height: 85%;\n  border-radius: 8px;\n}\n\n.chart-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  \n}\n.assessment-container {\n  padding: 0 25px;\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(30%, 1fr)); \n  gap: 20px; \n  margin-bottom: 25px;\n}\n\n.two-div-container {\n  padding: 0 25px;\n  display: grid;\n  grid-template-columns: 1fr 1.5fr; \n  gap: 40px; \n  margin-bottom: 25px;\n}\n\n.yoga-session-select {\n  width: 200px; \n  padding: 5px 10px; \n  font-size: 18px; \n  border: 1px solid #A0AEC0; \n  border-radius: 10px; \n  background-color: #fff; \n  color: #2D3748; \n}\n\n.yoga-session-select option {\n  color: gray; \n}\n\n\n.yoga-session-select::-ms-expand {\n  display: none; \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
